import dayjs from 'dayjs'

export function localizeImportedAt(importedAt, locale = "ja") {
  if (locale !== "ja") throw new Error("Not implemented yet")

  const localizedDate = dayjs(importedAt).tz(dayjs.tz.guess())

  switch (locale) {
    case "ja":
      return localizedDate.format('YYYY/MM/DD HH:mm:ss')
  }

  return importedAt
}



function localizeImportMethod(method, locale) {
  switch (locale) {
    case "ja":
      switch (method) {
        case "manual":
          return "手動インポート"
      }
  }
  return method
}


/**
 *
 * @param {{importedAt: string, importMethod: string}[]} rows
 * @param {string} locale
 */
export function localizeTableData(rows, locale = "ja") {
  if (locale !== "ja") throw new Error("Not implemented yet")

  return rows.map(row => {
    const newRow = {...row}
    newRow.importMethod = localizeImportMethod(row.importMethod, locale)
    newRow.importedAt = localizeImportedAt(row.importedAt, locale)
    return newRow
  })
}
